export default __webpack_public_path__ + "images/caebfb773df2d86560078a89ea1718d2-mamas-nightmarket.svg";